import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify'; // Assuming react-toastify is installed
import 'react-toastify/dist/ReactToastify.css'; // Import CSS for styling
import Urls from '../api/Urls';
import { LoaderMain, DashboardTopBar } from '../components/index';

const Settings = () => {
  const authToken = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(true);
  const [profileDetails, setProfileDetails] = useState();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const getProfileDetails = async () => {
      try {
        let res = await fetch(Urls.SERVER + Urls.SETTINGS, {
          method: "GET",
          headers: new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + authToken
          })
        });
        let resJson = await res.json();
        if (res.status === 200) {
          setProfileDetails(resJson.user);
          setEmail(resJson.user.email);
          setPhone(resJson.user.phone);
          setIsLoading(false);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getProfileDetails();
  }, []);

  const handleUpdate = async () => {
    setIsUpdating(true);
    try {
      let res = await fetch(Urls.SERVER + Urls.UPDATE_EMAIL_AND_PHONE, {
        method: "POST", // Assuming PUT for update; adjust if your API uses PATCH or another method
        headers: new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authToken
        }),
        body: JSON.stringify({ email, phone })
      });
      let resJson = await res.json();
      if (res.status === 200) {
        setProfileDetails(resJson.user); // Update profileDetails with the response
        toast.success('Profile updated successfully', {autoClose: 1500,  position: "top-center",});
      } else {
        toast.error('Failed to update profile', {autoClose: 1500,  position: "top-center",});
      }
    } catch (err) {
      toast.error('An error occurred while updating', {autoClose: 1500,  position: "top-center",});
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    isLoading ? <LoaderMain /> :
      <div style={{ flex: 1, paddingTop: '20px', minHeight: '100vh' }}>
        <DashboardTopBar title="Settings" />
        <div className='dashboard-content shadow-sm'>
          <div className='container'>
            <div className='row'>
              <div className='profile p-4'>
                <h6>Email</h6>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-control mb-2"
                />
                <hr />
                <h6>Phone</h6>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="form-control mb-2"
                />
                <hr />
                <button
                  onClick={handleUpdate}
                  disabled={isUpdating}
                  className="btn btn-primary"
                >
                  {isUpdating ? 'Updating...' : 'Update Profile'}
                </button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer /> {/* Add ToastContainer to render toasts */}
      </div>
  );
};

export default Settings;